/*App.js*/

/* global L */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Image } from 'react-bootstrap';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import axios from 'axios';
import { setCookie, getCookie } from './utils'; // Import the functions
import { useFirebaseAuth } from '../contexts/FirebaseAuthContext';
import AuthModal from '../components/Auth/AuthModal';
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css';
import connectlogo from "assets/img/btn_strava_connectwith_orange.png";
import { Chart } from "react-google-charts";
import HtmlContent from "components/Custom/htmlContent";
import content from 'content.json'; // Importing the JSON file
import 'assets/css/sort-buttons.css'; // Import sort button styles

// Fix for Leaflet icons in React - Temporarily Disabled
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//     iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
//     iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
//     shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
// });

// Create custom colored icons for different event sources - Temporarily Disabled
// const createCustomIcon = (color) => {
//     return L.divIcon({
//         className: 'custom-div-icon',
//         html: `<div style="
//             background-color: ${color};
//             width: 20px;
//             height: 20px;
//             border-radius: 50%;
//             border: 3px solid #fff;
//             box-shadow: 0 2px 6px rgba(0,0,0,0.3);
//         "></div>`,
//         iconSize: [20, 20],
//         iconAnchor: [10, 10]
//     });
// };

// const partyflockIcon = createCustomIcon('#9c27b0');
// const ticketmasterIcon = createCustomIcon('#ff6b35');
// const adeIcon = createCustomIcon('#00d4ff');

 
// todo: get brandname from env
const brandname = content.brandname;
const vApplication = content.application;
const vConnect_app_info = content.features.connect_app_info;

const login_api_url = process.env.REACT_APP_LOGIN_API_URL;
const resource_api_url = process.env.REACT_APP_RESOURCE_API_URL;
const env = process.env.NODE_ENV;
  // API URLs and configuration loaded  


function App() {
    // Component mount tracking
    const componentId = useRef(Math.random().toString(36).substr(2, 9));
    
    // State for event source selection
    const [includeADE, setIncludeADE] = useState(true);
    const [includeTicketmaster, setIncludeTicketmaster] = useState(true);
    const [includePartyflock, setIncludePartyflock] = useState(true);
    
    
    // Remove old custom styles since we're using the new CSS file
    useEffect(() => {
        // Any additional component-specific logic can go here
    }, []);

    const [showGoogleLogin, setShowGoogleLogin] = useState(true);
    const [user, setUser] = useState(null);
    const [strava_data, setStrava_data] = useState(null);
    // listItems is now computed via useMemo
    const [responseData, setResponseData] = useState({});
    const [loadingstatus, setLoadingstatus] = useState({});
    const [menu, setMenu] = useState('Lets get Started, checking if you are logged in');
    const [status, setStatus] = useState(null);
    const [showConnectButton, setShowConnectButton] = useState(false);
    const [chartKey, setChartKey] = useState(0);
    const [showChart, setShowChart] = useState(true);
    const [hasProceededWithMatching, setHasProceededWithMatching] = useState(false);
    
    // Firebase authentication state
    const { user: firebaseUser, isAuthenticated: firebaseAuthenticated } = useFirebaseAuth();
    const [showAuthModal, setShowAuthModal] = useState(false);

    // Handle authentication success
    const handleAuthSuccess = (data) => {
        setShowGoogleLogin(false);
        setShowAuthModal(false);
        checkToken();
    };

    // Handle authentication error
    const handleAuthError = (error) => {
        console.error('Authentication error:', error);
        setShowGoogleLogin(true);
    };


    
    const dataOld = [
        ["Name", "PPM"],
        ["Start", 0],
    ];
    
    const dataNew = [
        ["Name", "PPM"],
        ["Start", 0],
        
    ];
    
    const diffdatai = {
        old: dataOld,
        new: dataNew,
    };
    
    const options = {
        legend: {
            position: "top", 
            textStyle: { color: 'white' }  // Legend text color (white)
        },
        hAxis: {
            viewWindow: {
                max: 900,
                min: 700
            },
            textStyle: { color: 'white' }  // Horizontal axis label color (white)
        },
        vAxis: {
            textStyle: { color: 'white' }  // Vertical axis label color (white)
        },
        colors: ['#64b4c4', '#64b4c4'],  // Custom colors for bars
        series: {
            0: { color: '#64b4c4' },  // First series
            1: { color: '#64b4c4' },  // Second series
        },
        backgroundColor: '#000000',  // Background color (black)
        chartArea: {
            backgroundColor: '#000000',  // Chart area background color (black)
        },
        titleTextStyle: {
            color: 'white'  // Title text color (if you have a title)
        },
        annotations: {
            alwaysOutside: true,  // Place annotations outside the bars
            textStyle: {
                fontSize: 12,
                color: 'white',  // Annotation text color (white for visibility)
                auraColor: 'none'  // Disable the background behind the text
            }
        }
    };
  
    const [old_bar_data, setOld_bar_data] = useState(dataOld);
    const [new_bar_data, setNew_bar_data] = useState(dataNew);
    const [diffdata, setDiff_data] = useState(diffdatai);

    function onClickHandler(){
        
                    setMenu(<div className="status-message">After logging into google, please wait a few seconds for this page to load <br /><div className="google-login-wrapper">{googleLoginButton}</div></div>);
      }

    // iPhone-specific fix for Google OAuth
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    // Add iPhone-specific event listeners after component mounts
    useEffect(() => {
        if (isIOS && showGoogleLogin) {
            // Force Google OAuth iframe to be interactive on iOS
            const googleWrapper = document.querySelector('.google-login-wrapper');
            if (googleWrapper) {
                const iframes = googleWrapper.querySelectorAll('iframe');
                iframes.forEach(iframe => {
                    iframe.style.pointerEvents = 'auto';
                    iframe.style.touchAction = 'manipulation';
                    iframe.style.webkitTouchCallout = 'none';
                    iframe.style.webkitUserSelect = 'none';
                    iframe.style.userSelect = 'none';
                    iframe.style.webkitTapHighlightColor = 'transparent';
                    iframe.style.cursor = 'pointer';
                    iframe.style.webkitTransform = 'translateZ(0)';
                    iframe.style.transform = 'translateZ(0)';
                    iframe.style.webkitBackfaceVisibility = 'hidden';
                    iframe.style.backfaceVisibility = 'hidden';
                });
            }
        }
    }, [showGoogleLogin, isIOS]);

    const googleLoginButton = useMemo(() => {
        return (
            <GoogleLogin
                scope="openid email profile"
                shape='pill'
                click_listener={() => onClickHandler()}
                onSuccess={credentialResponse => {
                    // Redirecting to login
                    axios.post(`${login_api_url}/api/Login`, {
                        test: 'test'
                    }, {
                        headers: {
                            Authorization: credentialResponse.credential,
                        }
                    })
                        .then((res) => {
                            setCookie(`${brandname}_token`, res.data.token, { path: '/', expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365) });
                            setShowGoogleLogin(false);
                            checkToken();
                        })
                        .catch((error) => {
                            // Error occurred
                        });
                }}
                onError={() => {
                    // Login failed
                }}
                
            />
        );
    }, []);

    const authOptions = useMemo(() => {
        return (
            <div className="auth-options">
                <div className="auth-section">
                    <h5>Sign in with Google</h5>
                    <div className="google-login-wrapper">{googleLoginButton}</div>
                </div>
                <div className="auth-divider">
                    <span>or</span>
                </div>
                <div className="auth-section">
                    <h5>Sign in with Email</h5>
                    <button 
                        className="btn btn-primary btn-round"
                        onClick={() => setShowAuthModal(true)}
                        style={{ width: '100%' }}
                    >
                        Email & Password Login
                    </button>
                </div>
            </div>
        );
    }, [googleLoginButton]);

    const ConnectButton = useMemo(() => {
      
        return <button 
            className="btn btn-connect-spotify"
            onClick={() => {
                // Getting Spotify authorization code
                const clientId = 'bfdb5a89ac364da89f876b3d1fab1d9a';
                const redirectUri = `${resource_api_url}/api/Store_Tokens`;
                const scope = 'user-library-read';
                const state = getCookie(`${brandname}_token`);
                const response_type = 'code';
                const authUrl = `https://accounts.spotify.com/authorize?state=${state}&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=${response_type}`;
                window.open(authUrl, '_self');
            }}
        >
            <i className="fas fa-music" style={{ marginRight: '8px' }}></i>
            Connect to {vApplication}
        </button>
    
  }, []);

    function checkToken() {
        const cookieValue = getCookie(`${brandname}_token`);
        if (cookieValue) {
            axios.get(`${login_api_url}/api/CheckToken`, {
                headers: {
                    Authorization: cookieValue,
                }
            })
                .then(response => {
                    if (response.data.userid) {
                        // Use email if available, otherwise fallback to userid
                        const userIdentifier = response.data.email || response.data.userid;
                        setUser(userIdentifier);
                        setStatus(response.status);
                    }
                })
                .catch(error => {
                    setStatus(error.response.status);
                });
        } else {
            setStatus(401);
            setShowGoogleLogin(true);
        }
    }

    function checkPremiumStatus() {
        const cookieValue = getCookie(`${brandname}_token`);
        if (cookieValue) {
            axios.get(`${resource_api_url}/api/CheckPayment`, {
                headers: {
                    Authorization: cookieValue,
                }
            })
                .then(response => {
                    setIsPremium(response.data.has_paid);
                })
                .catch(error => {
                    // Error checking premium status
                    setIsPremium(false);
                });
        }
    }
    function fetchActivities(processed = 0) {
        // Set the initial loading message only on the first call
        if (processed === 0) {
            setMenu(<div className="status-message">Loading your tracks...</div>);
        }
        
        axios.get(`${resource_api_url}/api/Get_Activities?offset=${processed}`, {
            headers: {
                Authorization: getCookie(`${brandname}_token`),
            }
        })
        .then((res) => {
            if (res.status === 200) {
                // Get the body of the response, showing the percentage of items loaded
                const processedItems = res.data.processed;
                const totalItems = res.data.total;
    
                if (totalItems === 0) {
                    // User has no tracks
                    setMenu(<div className="status-message">No tracks found in your Spotify library. Please add some tracks to your Spotify library and try again.</div>);
                } else if (processedItems < totalItems) {
                    // Update the menu with progress
                    setMenu(<div className="status-message">Loading your tracks: {processedItems} of {totalItems}</div>);
                    // Continue fetching with a small delay to prevent overwhelming the server
                    setTimeout(() => {
                        fetchActivities(processedItems);
                    }, 100);
                } else {
                    // Call matching function after all activities are fetched
                    performMatching();
                }
            } else {
                setStatus(res.status);
            }
        })
        .catch((err) => {
            setStatus(err.response ? err.response.status : 'Error');
        });
    }
    
    function clearData() {
        axios.get(`${resource_api_url}/api/Clear_Data`, {
            headers: {
                Authorization: getCookie(`${brandname}_token`),
            }
        })
        .then((res) => {
            if (res.status === 200) {
                // Get the body of the response, showing the percentage of items loaded
                setMenu(`All items cleared`);
            } else {
                setStatus(res.status);
            }
        })
        .catch((err) => {
            setStatus(err.response ? err.response.status : 'Error');
        });
    }
    
    function extractPlaylistId(input) {
        // If it's already just a playlist ID (no URL), return as is
        if (!input.includes('spotify.com')) {
            return input.trim();
        }
        
        // Extract playlist ID from Spotify URL
        // Pattern: https://open.spotify.com/playlist/PLAYLIST_ID?si=...
        const match = input.match(/\/playlist\/([a-zA-Z0-9]+)/);
        if (match && match[1]) {
            return match[1];
        }
        
        // If no match found, return the original input
        return input.trim();
    }

    function storePlaylistId(playlistId) {
        setMenu(<div className="status-message">Saving your playlist ID...</div>);
        
        axios.post(`${resource_api_url}/api/StorePlaylist`, {
            playlist_id: playlistId
        }, {
            headers: {
                Authorization: getCookie(`${brandname}_token`),
            }
        })
        .then((res) => {
            if (res.status === 200) {
                setMenu(<div className="status-message success">Playlist ID saved successfully! Redirecting...</div>);
                // Wait a moment then check user status again
                setTimeout(() => {
                    checkToken();
                }, 1500);
            } else {
                setMenu(<div className="status-message error">Failed to save playlist ID. Please try again.</div>);
            }
        })
        .catch((err) => {
            setMenu(<div className="status-message error">Error saving playlist ID. Please try again.</div>);
            console.error('Error storing playlist ID:', err);
        });
    }
    
    useEffect(() => {
        switch (status) {
            case 401:
                setMenu(<div className="status-message">Welcome, this is a first-time visit. Please log in to continue <br />{authOptions}</div>);
                break;
            case 202:
                setMenu(<div className="status-message">Logged in / Authenticated, checking if we have your playlist.</div>);
                axios.get(`${resource_api_url}/api/User`, {
                    headers: {
                        Authorization: getCookie(`${brandname}_token`),
                    },
                    // Ensure we can access custom headers
                    withCredentials: false
                })
                    .then((res) => {
                        setStatus(res.status);
                        console.log('res.status', res.status);
                        // If status is 204, extract playlist ID from header
                        if (res.status === 204) {
                            console.log('res.headers', res.headers);
                            console.log('All response headers:', Object.keys(res.headers));
                            
                            // Try different header name variations
                            const playlistIdFromHeader = res.headers['x-playlist-id'] || 
                                                       res.headers['X-Playlist-ID'] || 
                                                       res.headers['X-PLAYLIST-ID'];
                            
                            console.log('Playlist ID from header:', playlistIdFromHeader);
                            
                            if (playlistIdFromHeader) {
                                setPlaylistId(playlistIdFromHeader);
                                // Store in localStorage for future fallback
                                localStorage.setItem(`${brandname}_playlist_id`, playlistIdFromHeader);
                                console.log('Playlist ID extracted from header:', playlistIdFromHeader);
                            } else {
                                console.log('No playlist ID found in headers');
                                console.log('Available headers:', res.headers);
                                
                                // Fallback: Try to get playlist ID from localStorage
                                const storedPlaylistId = localStorage.getItem(`${brandname}_playlist_id`);
                                if (storedPlaylistId) {
                                    console.log('Using stored playlist ID from localStorage:', storedPlaylistId);
                                    setPlaylistId(storedPlaylistId);
                                } else {
                                    console.log('No playlist ID available from header or localStorage');
                                }
                            }
                        }
                    })
                    .catch((err) => {
                        setStatus(err.response.status);
                    });
                break;
            case 204:
                setMenu(
                    <div className="playlist-confirmation-container" style={{ backgroundColor: '#2a2a2a', padding: '20px', borderRadius: '8px', border: '2px solid #555' }}>
                        <div className="status-message success" style={{ marginBottom: '16px' }}>
                            <i className="fas fa-check-circle" style={{ color: '#28a745', marginRight: '8px' }}></i>
                            We found your playlist!
                        </div>
                        <div style={{ marginBottom: '16px' }}>
                            <strong>Playlist ID:</strong> 
                            <span style={{ 
                                backgroundColor: '#1a1a1a', 
                                padding: '8px 12px', 
                                borderRadius: '4px', 
                                marginLeft: '8px',
                                fontFamily: 'monospace',
                                color: '#fff'
                            }}>
                                {playlistId || 'Loading...'}
                            </span>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                            <button 
                                className="btn btn-warning"
                                onClick={() => {
                                    // Change playlist ID - redirect to 404 case
                                    setStatus(404);
                                }}
                                style={{
                                    backgroundColor: '#ffc107',
                                    border: 'none',
                                    color: '#000',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                            >
                                <i className="fas fa-edit"></i>
                                Change Playlist ID
                            </button>
                        </div>
                    </div>
                );
                break;

                // axios.get(`${resource_api_url}/api/Get_Activities?offset=0`, {
                //     headers: {
                //         Authorization: getCookie(`${brandname}_token`),
                //     }
                // })
                //     .then((res) => {
                //         if (res.status === 200) {
                            
                //             setStrava_data(res.data.items);
                            
                //             console.log('res.items', res.data.items);
                //             console.log('stravadata', strava_data);
                //             // setStrava_data(res.data);
                //         } else {
                //             setStatus(res.status);
                //         }
                //     })
                //     .catch((err) => {
                //         setStatus(err.response.status);
                //     });
                break;
            case 404:
                setMenu(
                    // provide your playlist id here in this input field
                    <div className="playlist-id-container" style={{ backgroundColor: '#2a2a2a', padding: '16px', borderRadius: '8px', border: '2px solid #555' }}>
                        Please make sure this is a personal and public playlist. Paste the full url after sharing from Spotify.
                        <input 
                            type="text" 
                            id="playlist-id-input"
                            className="playlist-id-input" 
                            placeholder="Enter playlist ID or Spotify URL" 
                            style={{ 
                                backgroundColor: '#1a1a1a', 
                                color: '#fff', 
                                border: '1px solid #666', 
                                borderRadius: '4px', 
                                padding: '8px 12px', 
                                fontSize: '14px',
                                fontFamily: 'Courier New, monospace',
                                width: '100%',
                                outline: 'none',
                                marginBottom: '12px'
                            }}
                        />
                        <button 
                            className="btn btn-primary"
                            onClick={() => {
                                const playlistInput = document.getElementById('playlist-id-input').value;
                                if (playlistInput.trim()) {
                                    const extractedPlaylistId = extractPlaylistId(playlistInput);
                                    storePlaylistId(extractedPlaylistId);
                                } else {
                                    alert('Please enter a playlist ID or URL');
                                }
                            }}
                            style={{
                                backgroundColor: '#1db954',
                                border: 'none',
                                borderRadius: '4px',
                                padding: '8px 16px',
                                color: '#fff',
                                fontSize: '14px',
                                cursor: 'pointer',
                                width: '100%'
                            }}
                        >
                            <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                            Save Playlist ID
                        </button>
                    </div>
                
                );
                break;
            case 440:
                setMenu(<div className="status-message">Session Expired, please log in again <br />{authOptions}</div>);
                setShowGoogleLogin(true);
                break;
            default:
                // Unknown status received
                checkToken();
                break;
        }
    }, [status, googleLoginButton]);

    const updateStatus = (entryId, status) => {
        return new Promise((resolve) => {
            setLoadingstatus(prevStatus => {
                const newStatus = { ...prevStatus, [entryId]: status };
                resolve(newStatus);
                return newStatus;
            });
        });
    };

    const handleButtonClick = (entry, module=null, type) => {
        // First update the status
        if (type === 'station') {
            setLoadingstatus(prevStatus => ({
                ...prevStatus,
                [entry._id]: 'Getting data...'
            }));
        } else {
            setLoadingstatus(prevStatus => ({
                ...prevStatus,
                [module._id]: 'Getting data...'
            }));
        }
    
        // Ensure the UI updates before making the API call
        setTimeout(() => {
            axios.post(`${resource_api_url}/api/Get_Activity`, {
                station_id: entry._id,
                module_id: module ? module._id : null,
                type: type
            }, {
                headers: {
                    Authorization: getCookie(`${brandname}_token`),
                }
            })
                .then((res) => {
                    
                    
                    const newDataArray = (type == 'station') ?  [entry.station_name, res.data.today] : [module.module_name, res.data.today];
                    const oldDataArray = (type == 'station') ?  [entry.station_name, res.data.yesterday] : [module.module_name, res.data.yesterday];
                    ;  // Create new data row (ID and data)
    
                    // Update bar_data by appending the new row
                    const updatedOldBarData = [...old_bar_data, oldDataArray];
                    const updatedNewBarData = [...new_bar_data, newDataArray];
    
                    setOld_bar_data(updatedOldBarData);
                    setNew_bar_data(updatedNewBarData);
    
                    // Now update diffdata with the updated bar data
                    setDiff_data({
                        old: updatedOldBarData,
                        new: updatedNewBarData,
                    });
    
                    if (type === 'station') {
                        setLoadingstatus(prevStatus => ({
                            ...prevStatus,
                            [entry._id]: 'Here is your data'
                        }));
                        setResponseData(prevData => ({
                            ...prevData,
                            [entry._id]: res.data
                        }));
                    } else {
                        setLoadingstatus(prevStatus => ({
                            ...prevStatus,
                            [module._id]: 'Here is your data'
                        }));
                        setResponseData(prevData => ({
                            ...prevData,
                            [module._id]: res.data
                        }));
                    }
                })
                .catch((err) => {
                    if (err.response.status === 401) {
                        setShowGoogleLogin(true);
                    } else if (err.response.status === 404) {
                        setShowConnectButton(true);
                    }
                });
        }, 100); // Adding a small delay to ensure UI update
    };

    

    const [expandedEvents, setExpandedEvents] = useState({});
    const [expandedArtists, setExpandedArtists] = useState({});
    const [isPremium, setIsPremium] = useState(false);
    const [metadata, setMetadata] = useState(null);
    const [sortBy, setSortBy] = useState('tracks'); // 'tracks' or 'date'
    const [playlistId, setPlaylistId] = useState(null);
    const [ticketUrls, setTicketUrls] = useState({});
    const [loadingTicketUrls, setLoadingTicketUrls] = useState({});
    const [ticketCheckComplete, setTicketCheckComplete] = useState({});
    const [ticketState, setTicketState] = useState({});
    const [mapMarkers, setMapMarkers] = useState([]);
    const [embedMapUrl, setEmbedMapUrl] = useState('');

    // Initialize Leaflet map when markers change
    useEffect(() => {
        console.log('🗺️ [LEAFLET DEBUG] useEffect for map initialization triggered');
        console.log('🗺️ [LEAFLET DEBUG] mapMarkers.length:', mapMarkers.length);
        
        if (mapMarkers.length > 0) {
            // Small delay to ensure DOM is ready
            setTimeout(() => {
                initializeLeafletMap(mapMarkers);
            }, 100);
        }
    }, [mapMarkers]);

    // Function to generate map markers from event data
    const generateMapMarkers = (eventsData) => {
        if (!eventsData || typeof eventsData !== 'object') return [];
        
        const markers = [];
        console.log('🗺️ [MAP DEBUG] generateMapMarkers called with eventsData:', eventsData);
        
        Object.keys(eventsData).forEach((eventName) => {
            const event = eventsData[eventName];
            console.log(`🗺️ [MAP DEBUG] Processing event: ${eventName}`, {
                latitude: event.latitude,
                longitude: event.longitude,
                hasLat: !!event.latitude,
                hasLng: !!event.longitude,
                latType: typeof event.latitude,
                lngType: typeof event.longitude
            });
            
            // Only include events with valid coordinates
            if (event.latitude && event.longitude) {
                // Get all artist names for this event
                const artistNames = Object.keys(event.artists || {});
                const artistList = artistNames.length > 0 ? artistNames.join(', ') : 'Unknown Artist';
                
                const marker = {
                    id: eventName,
                    title: eventName,
                    artists: artistList,
                    venue: event.venue || 'Unknown Venue',
                    city: event.city || 'Unknown City',
                    lat: parseFloat(event.latitude),
                    lng: parseFloat(event.longitude),
                    source: event.source || 'unknown',
                    url: event.url || '',
                    date: event.start_date || 'Unknown Date'
                };
                
                console.log(`🗺️ [MAP DEBUG] Created marker for ${eventName}:`, marker);
                markers.push(marker);
            } else {
                console.log(`🗺️ [MAP DEBUG] Skipping ${eventName} - missing coordinates:`, {
                    latitude: event.latitude,
                    longitude: event.longitude
                });
            }
        });
        
        console.log('🗺️ [MAP DEBUG] Total markers generated:', markers.length);
        return markers;
    };

    // Generate Google Maps Embed API URL
    // Initialize Leaflet map
    const initializeLeafletMap = (markers) => {
        console.log('🗺️ [LEAFLET DEBUG] initializeLeafletMap called');
        console.log('🗺️ [LEAFLET DEBUG] markers.length:', markers.length);

        if (!markers || markers.length === 0) {
            console.log('🗺️ [LEAFLET DEBUG] No markers provided');
            return;
        }

        // Calculate center point from all markers
        const centerLat = markers.reduce((sum, marker) => sum + marker.lat, 0) / markers.length;
        const centerLng = markers.reduce((sum, marker) => sum + marker.lng, 0) / markers.length;
        
        console.log('🗺️ [LEAFLET DEBUG] Center point:', centerLat, centerLng);

        // Initialize the map
        const map = L.map('leaflet-map').setView([centerLat, centerLng], 6);

        // Add OpenStreetMap tiles
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        // Create custom icons for different event sources
        const createCustomIcon = (color) => {
            return L.divIcon({
                className: 'custom-div-icon',
                html: `<div style="
                    background-color: ${color};
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    border: 3px solid #fff;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
                "></div>`,
                iconSize: [20, 20],
                iconAnchor: [10, 10]
            });
        };

        const adeIcon = createCustomIcon('#00d4ff');
        const ticketmasterIcon = createCustomIcon('#ff6b35');
        const partyflockIcon = createCustomIcon('#9c27b0');

        // Add markers for each event
        markers.forEach(marker => {
            let icon;
            switch (marker.source) {
                case 'ticketmaster':
                    icon = ticketmasterIcon;
                    break;
                case 'partyflock':
                    icon = partyflockIcon;
                    break;
                default:
                    icon = adeIcon;
            }

            const leafletMarker = L.marker([marker.lat, marker.lng], { icon: icon }).addTo(map);
            
            // Create popup content
            const popupContent = `
                <div style="color: #000; max-width: 300px;">
                    <h3 style="margin: 0 0 10px 0; color: #333; font-size: 16px;">${marker.title}</h3>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;">
                        <strong>Artists:</strong> ${marker.artists}
                    </p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;">
                        <strong>Venue:</strong> ${marker.venue}
                    </p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;">
                        <strong>City:</strong> ${marker.city}
                    </p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;">
                        <strong>Date:</strong> ${marker.date}
                    </p>
                    <p style="margin: 5px 0; color: #666; font-size: 14px;">
                        <strong>Source:</strong> ${marker.source.toUpperCase()}
                    </p>
                    ${marker.url ? `
                        <a href="${marker.url}" target="_blank" style="
                            display: inline-block;
                            margin-top: 10px;
                            padding: 8px 16px;
                            background-color: ${marker.source === 'partyflock' ? '#9c27b0' : 
                                           marker.source === 'ticketmaster' ? '#ff6b35' : '#00d4ff'};
                            color: white;
                            text-decoration: none;
                            border-radius: 4px;
                            font-size: 14px;
                            font-weight: bold;
                        ">
                            View Event Details
                        </a>
                    ` : ''}
                </div>
            `;
            
            leafletMarker.bindPopup(popupContent);
        });

        console.log('🗺️ [LEAFLET DEBUG] Map initialized with', markers.length, 'markers');
    };


    const isValidTicketUrl = (url) => {
        if (!url) return false;
        const ticketDomains = [
            'eventix.shop', 'tickets.nl', 'eventbrite.com', 'feverup.com',
            'partyflock.nl', 'facebook.com/events', 'residentadvisor.net', 'fatso.ma'
        ];
        const isTicketPlatform = ticketDomains.some(domain => url.includes(domain));
        const isNotVenueUrl = !url.includes('/venues/') && !url.includes('/en/venues/') && !url.includes('amsterdam-dance-event.nl/en/venues/');
        return isTicketPlatform && isNotVenueUrl;
    };

    // Function to extract ticket URL from THE Dance Event Festival in Amsterdam page by searching for specific button classes
    const extractTicketUrl = async (eventUrl, eventName) => {
        if (!eventUrl || (ticketState[eventName] && ticketState[eventName].complete)) {
            return; // Already processed or no URL
        }

        setTicketState(prev => ({
            ...prev,
            [eventName]: {
                loading: true,
                ticketUrl: null,
                complete: false
            }
        }));

        try {
            // Fast direct fetch with multiple proxy fallbacks for speed
            const proxies = [
                `https://api.allorigins.win/get?url=${encodeURIComponent(eventUrl)}`,
                `https://corsproxy.io/?${encodeURIComponent(eventUrl)}`,
                `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent(eventUrl)}`,
                `https://thingproxy.freeboard.io/fetch/${eventUrl}`
            ];
            
            let response, data;
            for (const proxyUrl of proxies) {
                try {
                    response = await fetch(proxyUrl, {
                        method: 'GET',
                        headers: {
                            'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8'
                        }
                    });
                    
                    if (response.ok) {
                        data = await response.json();
                        if (data.contents) break;
                    }
                } catch (e) {
                    continue; // Try next proxy
                }
            }
            
            if (data && data.contents) {
                // Fast regex-based parsing instead of DOM parsing
                const html = data.contents;
                let ticketUrl = '';
                
                // Fast regex patterns for ticket URLs (in order of likelihood)
                const patterns = [
                    /href="([^"]*eventix\.shop[^"]*)"/i,
                    /href="([^"]*tickets\.nl[^"]*)"/i,
                    /href="([^"]*eventbrite\.com[^"]*)"/i,
                    /href="([^"]*feverup\.com[^"]*)"/i,
                    /href="([^"]*partyflock\.nl[^"]*)"/i,
                    /href="([^"]*facebook\.com\/events[^"]*)"/i,
                    /href="([^"]*residentadvisor\.net[^"]*)"/i,
                    /href="([^"]*fatso\.ma[^"]*)"/i,
                    /class="[^"]*ade-button[^"]*"[^>]*href="([^"]*)"/i,
                    /class="[^"]*ade-info-bar_button[^"]*"[^>]*href="([^"]*)"/i
                ];
                
                for (const pattern of patterns) {
                    const match = html.match(pattern);
                    if (match && match[1]) {
                        ticketUrl = match[1];
                        if (isValidTicketUrl(ticketUrl)) break;
                    }
                }
                
                if (ticketUrl && isValidTicketUrl(ticketUrl)) {
                    console.log(`Found valid ticket URL for ${eventName}: ${ticketUrl}`);
                    setTicketState(prev => ({
                        ...prev,
                        [eventName]: {
                            loading: false,
                            ticketUrl: ticketUrl,
                            complete: true
                        }
                    }));
                } else {
                    console.log(`No valid ticket URL found for ${eventName}. Found URL: ${ticketUrl || 'none'}`);
                    setTicketState(prev => ({
                        ...prev,
                        [eventName]: {
                            loading: false,
                            ticketUrl: null,
                            complete: true
                        }
                    }));
                }
            } else {
                // No content found
                setTicketState(prev => ({
                    ...prev,
                    [eventName]: {
                        loading: false,
                        ticketUrl: null,
                        complete: true
                    }
                }));
            }
        } catch (error) {
            console.error(`Error extracting ticket URL for ${eventName}:`, error);
        } finally {
            // Ensure loading is set to false even if there was an error
            if (!ticketState[eventName] || !ticketState[eventName].complete) {
                setTicketState(prev => ({
                    ...prev,
                    [eventName]: {
                        loading: false,
                        ticketUrl: prev[eventName]?.ticketUrl || null,
                        complete: true
                    }
                }));
            }
        }
    };


    const toggleEventExpand = (eventName) => {
        const isExpanding = !expandedEvents[eventName];
        
        setExpandedEvents((prevState) => ({
            ...prevState,
            [eventName]: !prevState[eventName],
        }));
        
        // TEMPORARILY DISABLED: Fetch ticket URL when expanding an event (if not already fetched)
        // if (isExpanding && strava_data && strava_data[eventName] && strava_data[eventName].url && (!ticketState[eventName] || !ticketState[eventName].complete)) {
        //     extractTicketUrl(strava_data[eventName].url, eventName);
        // }
    };

    const toggleArtistExpand = (eventName, artistName) => {
        setExpandedArtists((prevState) => ({
            ...prevState,
            [eventName]: {
                ...prevState[eventName],
                [artistName]: !prevState[eventName]?.[artistName],
            },
        }));
    };

    const listItems = useMemo(() => {
        if (strava_data && typeof strava_data === 'object') {
            const modifiedStravaData = { ...strava_data };

            // Check if there are any events (no matches case)
            if (Object.keys(modifiedStravaData).length === 0) {
                return null;
            }

Object.keys(modifiedStravaData).forEach((eventName) => {
    const event = modifiedStravaData[eventName];
    const artistCount = Object.keys(event.artists).length;
    
    const trackCount = Object.keys(event.artists).reduce(
        (totalTracks, artistName) => totalTracks + Object.keys(event.artists[artistName].tracks).length,
        0
    );

    // Add new keys at the event level
    event.artistCount = artistCount;
    event.trackCount = trackCount;
});
// Step 3: Convert object to array and sort by trackCount or date
const sortedEventsArray = Object.entries(modifiedStravaData)
    .sort(([, eventA], [, eventB]) => {
        if (sortBy === 'date') {
            // Sort by date (oldest first - ascending)
            return new Date(eventA.start_date) - new Date(eventB.start_date);
        } else {
            // Sort by track count (highest first)
            return eventB.trackCount - eventA.trackCount;
        }
    });

// Step 4: Convert sorted array back to object
const sortedStravaData = Object.fromEntries(sortedEventsArray);

// Data sorted successfully
            const items = Object.keys(sortedStravaData).map((eventName) => (
                <div key={eventName} className="event-card">
                    <div className="event-card-header" onClick={() => toggleEventExpand(eventName)}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h3 className="event-title">
                                    {eventName}
                                </h3>
                                <div className="event-date">
                                    {new Date(strava_data[eventName].start_date).toLocaleDateString('en-US', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    })}
                                </div>
                                
                                {/* Show venue, city, and country information for Ticketmaster and Partyflock events */}
                                {(modifiedStravaData[eventName]?.source === 'ticketmaster' || modifiedStravaData[eventName]?.source === 'partyflock') && (
                                    <div className="event-location" style={{
                                        marginTop: '8px',
                                        fontSize: '14px',
                                        color: '#F59E0B',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '4px'
                                    }}>
                                        {strava_data[eventName].venue && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="fas fa-map-marker-alt" style={{ color: modifiedStravaData[eventName]?.source === 'partyflock' ? '#9c27b0' : '#ff6b35' }}></i>
                                                <span style={{ fontWeight: 'bold' }}>{strava_data[eventName].venue}</span>
                                            </div>
                                        )}
                                        {(strava_data[eventName].city || strava_data[eventName].country) && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '20px' }}>
                                                <i className="fas fa-globe" style={{ color: '#F59E0B' }}></i>
                                                <span>
                                                    {[strava_data[eventName].city, strava_data[eventName].country]
                                                        .filter(Boolean)
                                                        .join(', ')}
                                                </span>
                                            </div>
                                        )}
                                        {/* Show coordinates for debugging */}
                                        {(strava_data[eventName].latitude && strava_data[eventName].longitude) && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '20px' }}>
                                                <i className="fas fa-crosshairs" style={{ color: '#ff6b35' }}></i>
                                                <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#ff6b35' }}>
                                                    Lat: {strava_data[eventName].latitude}, Lng: {strava_data[eventName].longitude}
                                                </span>
                                            </div>
                                        )}
                                        {(!strava_data[eventName].latitude || !strava_data[eventName].longitude) && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '20px' }}>
                                                <i className="fas fa-exclamation-triangle" style={{ color: '#ff6b35' }}></i>
                                                <span style={{ fontFamily: 'monospace', fontSize: '12px', color: '#ff6b35' }}>
                                                    ⚠️ Missing coordinates
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                {/* Show Buy Tickets button for Ticketmaster and Partyflock events */}
                                {(modifiedStravaData[eventName]?.source === 'ticketmaster' || modifiedStravaData[eventName]?.source === 'partyflock') && strava_data[eventName].url && (
                                    <div className="event-url" style={{ marginTop: '12px' }}>
                                        <a 
                                            href={strava_data[eventName].url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="ticket-link"
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                backgroundColor: modifiedStravaData[eventName]?.source === 'partyflock' ? '#9c27b0' : '#ff6b35',
                                                color: '#fff',
                                                padding: '10px 16px',
                                                borderRadius: '6px',
                                                textDecoration: 'none',
                                                fontWeight: 'bold',
                                                fontSize: '14px',
                                                transition: 'all 0.3s ease',
                                                boxShadow: modifiedStravaData[eventName]?.source === 'partyflock' ? '0 2px 8px rgba(156, 39, 176, 0.3)' : '0 2px 8px rgba(255, 107, 53, 0.3)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = modifiedStravaData[eventName]?.source === 'partyflock' ? '#7b1fa2' : '#e55a2b';
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.boxShadow = modifiedStravaData[eventName]?.source === 'partyflock' ? '0 4px 12px rgba(156, 39, 176, 0.4)' : '0 4px 12px rgba(255, 107, 53, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = modifiedStravaData[eventName]?.source === 'partyflock' ? '#9c27b0' : '#ff6b35';
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = modifiedStravaData[eventName]?.source === 'partyflock' ? '0 2px 8px rgba(156, 39, 176, 0.3)' : '0 2px 8px rgba(255, 107, 53, 0.3)';
                                            }}
                                        >
                                            <i className="fas fa-ticket-alt"></i>
                                            Buy Tickets
                                        </a>
                                    </div>
                                )}
                                
                                {/* TEMPORARILY HIDDEN: Event Details Link */}
                                {/* {strava_data[eventName].url && (
                                    <div className="event-url">
                                        <a 
                                            href={strava_data[eventName].url} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="event-link"
                                        >
                                            <i className="fas fa-external-link-alt"></i>
                                            View Event Details
                                        </a>
                                    </div>
                                )} */}
                                {/* TEMPORARILY HIDDEN: Ticket URL Section and Find Tickets Button */}
                                {/* {strava_data[eventName].url && (
                                    <div className="ticket-url">
                                        {ticketState[eventName]?.loading ? (
                                            <span className="ticket-loading">
                                                <i className="fas fa-spinner fa-spin"></i>
                                                Finding tickets...
                                            </span>
                                        ) : ticketState[eventName]?.ticketUrl ? (
                                            <a 
                                                href={ticketState[eventName].ticketUrl} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="ticket-link ade-button ade-info-bar_button"
                                            >
                                                <i className="fas fa-ticket-alt"></i>
                                                Buy Tickets
                                            </a>
                                        ) : ticketState[eventName]?.complete ? (
                                            <span style={{ color: '#888', fontStyle: 'italic' }}>
                                                No tickets found
                                            </span>
                                        ) : (
                                            // Only show "Find Tickets" button for THE Dance Event Festival in Amsterdam, not Ticketmaster events
                                            modifiedStravaData[eventName]?.source !== 'ticketmaster' && (
                                                <button 
                                                    className="find-tickets-btn"
                                                    onClick={() => extractTicketUrl(strava_data[eventName].url, eventName)}
                                                    style={{
                                                        background: 'transparent',
                                                        border: '1px solid #F59E0B',
                                                        color: '#F59E0B',
                                                        padding: '8px 16px',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        transition: 'all 0.3s ease',
                                                        marginTop: '10px'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#F59E0B';
                                                        e.target.style.color = '#000';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'transparent';
                                                        e.target.style.color = '#F59E0B';
                                                    }}
                                                >
                                                    <i className="fas fa-search"></i>
                                                    Find Tickets
                                                </button>
                                            )
                                        )}
                                    </div>
                                )} */}
                            </div>
                            <div className="event-badges">
                                <span className="event-badge artists">
                                    {modifiedStravaData[eventName].artistCount} Artists
                                </span>
                                <span className="event-badge tracks">
                                    {modifiedStravaData[eventName].trackCount} Tracks
                                </span>
                                {/* Event source indicator */}
                                <span 
                                    className="event-badge source"
                                    style={{
                                        backgroundColor: modifiedStravaData[eventName]?.source === 'ticketmaster' ? '#ff6b35' : '#00d4ff',
                                        color: '#000',
                                        fontWeight: 'bold',
                                        fontSize: '11px',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    {modifiedStravaData[eventName]?.source === 'ticketmaster' ? (
                                        <>
                                            <i className="fas fa-ticket-alt"></i>
                                            TM
                                        </>
                                    ) : modifiedStravaData[eventName]?.source === 'partyflock' ? (
                                        <>
                                            <i className="fas fa-calendar-alt"></i>
                                            PF
                                        </>
                                    ) : (
                                        <>
                                            <i className="fas fa-music"></i>
                                            THE Dance Event Festival in Amsterdam
                                        </>
                                    )}
                                </span>
                                <button className="add-button">
                                    {expandedEvents[eventName] ? '−' : '+'}
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    {expandedEvents[eventName] && (
                        <div className="card-body">
                            {Object.keys(strava_data[eventName].artists).map((artistName) => (
                                <div key={artistName} className="artist-section">
                                    <div className="d-flex justify-content-between align-items-center" 
                                         style={{ cursor: 'pointer' }}
                                         onClick={() => toggleArtistExpand(eventName, artistName)}>
                                        <h4 className="artist-title">
                                            {artistName}
                                        </h4>
                                        <div className="d-flex align-items-center">
                                            <span className="event-badge tracks">
                                                {Object.keys(strava_data[eventName].artists[artistName].tracks).length} Tracks
                                            </span>
                                            <button className="add-button" style={{ width: '24px', height: '24px', fontSize: '1rem' }}>
                                                {expandedArtists[eventName]?.[artistName] ? '−' : '+'}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    {expandedArtists[eventName]?.[artistName] && (
                                        <div className="tracks-grid">
                                            {Object.keys(strava_data[eventName].artists[artistName].tracks).map(
                                                (trackName) => (
                                                    <div key={trackName} className="track-card">
                                                        <a
                                                            href={
                                                                strava_data[eventName].artists[artistName].tracks[
                                                                    trackName
                                                                ]
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i className="fas fa-music track-icon"></i>
                                                            <span>{trackName}</span>
                                                        </a>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ));
            return items;
        } else {
            // Data format validation
            return null;
        }
    }, [strava_data, responseData, loadingstatus, expandedEvents, expandedArtists, sortBy, ticketState]);
    
    // Handle success message when listItems changes
    useEffect(() => {
        if (listItems && listItems.length > 0) {
            setMenu(<div className="status-message success">Consider planning these events as you have Spotify tracks of these artists</div>);
        } else if (listItems === null && strava_data && Object.keys(strava_data).length === 0) {
            setMenu(<div className="status-message">Unfortunately, there are no matches</div>);
        }
    }, [listItems, strava_data]);

    const cleardata = () => {
        // Step 1: Hide the chart and set data states to null/empty to fully clear out
        setShowChart(false);  // Temporarily hide the chart
        
        setDiff_data(null);    // Clear diffdata to reset chart
        setOld_bar_data([]);   // Clear old bar data
        setNew_bar_data([]);   // Clear new bar data
    
        // Step 2: Reinitialize the chart data after a small delay to ensure full reset
        setTimeout(() => {
            const dataOld = [
                ["Name", "PPM"],
                ["Start", 0],
            ];
    
            const dataNew = [
                ["Name", "PPM"],
                ["Start", 0],
            ];
    
            const diffdatai = {
                old: dataOld,
                new: dataNew,
            };
    
            // Step 3: Reset the state with fresh data
            setOld_bar_data(dataOld);
            setNew_bar_data(dataNew);
            setDiff_data(diffdatai);  // Reset the chart data
    
            // Step 4: Show the chart again by setting showChart to true
            setShowChart(true);  // Reintroduce the chart
        }, 500); // Use a delay to ensure the chart component fully unmounts
    };

    const performMatching = () => {
        // Build query parameters for scope selection
        const params = new URLSearchParams();
        params.append('include_ade', includeADE.toString());
        params.append('include_ticketmaster', includeTicketmaster.toString());
        params.append('include_partyflock', includePartyflock.toString());
        
        axios.get(`${resource_api_url}/api/Matching?${params.toString()}`, {
            headers: {
                Authorization: getCookie(`${brandname}_token`),
            }
        })
        .then((res) => {
            if (res.status === 200) {
                // Response data received
                console.log('✅ Matching successful:', res.data);
                
                // Check if response has metadata (limited results for non-premium users)
                if (res.data._metadata && res.data._metadata.is_premium === false) {
                    setMetadata(res.data._metadata);
                    setIsPremium(false);
                    // Remove metadata from the data before setting it
                    const { _metadata, ...dataWithoutMetadata } = res.data;
                    setStrava_data(dataWithoutMetadata);
                    // Generate map markers for the data
                    const markers = generateMapMarkers(dataWithoutMetadata);
                    setMapMarkers(markers);
                } else {
                    setMetadata(null);
                    setIsPremium(true);
                    setStrava_data(res.data);
                    // Generate map markers for the data
                    const markers = generateMapMarkers(res.data);
                    setMapMarkers(markers);
                }
            } else {
                setStatus(res.status);
            }
        })
        .catch((err) => {
            console.error('❌ Matching failed:', err);
            setStatus(err.response ? err.response.status : 'Error');
        });
    };


    return (
        <>
        <style>
            {`
                .custom-div-icon {
                    background: transparent !important;
                    border: none !important;
                }
                #leaflet-map {
                    z-index: 1;
                }
            `}
        </style>
        <div className="content">


    {/* <button onClick={() => clearData()}>ClearData</button>
    <button onClick={() => fetchActivities()}>fetch Tracks</button>
    <button onClick={() => matching()}>Matching</button>
    <button onClick={() => cleardata()}>Clear</button> */}


            <div className="event-results-container">
                <div className="data-update-banner">
                    🎉&nbsp; Updated for ADE 2026 — new lineups &amp; events loaded
                </div>
                {!showGoogleLogin && (
                    <div className="user-info">
                        <p className="user-name">{user}</p>
                        {isPremium && (
                            <span className="premium-badge-user">
                                ⭐ Premium
                            </span>
                        )}
                    </div>
                )}
                
                
                {menu && (
                    <div className="event-banner">
                        {menu}
                    </div>
                )}
                
                {/* Event Source Selection - MOVED OUTSIDE NESTED STRUCTURE */}
                {status === 204 && (
                    <div style={{ 
                        marginTop: '30px',
                        marginBottom: '20px', 
                        padding: hasProceededWithMatching ? '10px 15px' : '20px', 
                        backgroundColor: (!includeADE && !includeTicketmaster) ? '#ffe6e6' : '#f8f9fa', 
                        borderRadius: hasProceededWithMatching ? '8px' : '12px', 
                        border: (!includeADE && !includeTicketmaster) ? '3px solid #dc3545' : '2px solid #28a745',
                        transition: 'all 0.3s ease',
                        boxShadow: hasProceededWithMatching ? '0 2px 6px rgba(0,0,0,0.1)' : '0 4px 12px rgba(0,0,0,0.1)'
                    }}>
                        {hasProceededWithMatching ? (
                            <div style={{ 
                                textAlign: 'center',
                                fontSize: '14px',
                                color: '#28a745',
                                fontWeight: 'bold'
                            }}>
                                <i className="fas fa-check-circle" style={{ marginRight: '8px' }}></i>
                                Selected Sources: {includeADE ? 'ADE' : ''}{includeADE && (includeTicketmaster || includePartyflock) ? ' + ' : ''}{includeTicketmaster ? 'Ticketmaster' : ''}{(includeADE || includeTicketmaster) && includePartyflock ? ' + ' : ''}{includePartyflock ? 'Partyflock' : ''}
                            </div>
                        ) : (
                            <h4 style={{ 
                                marginBottom: '20px', 
                                color: (!includeADE && !includeTicketmaster) ? '#dc3545' : '#28a745', 
                                fontSize: '20px',
                                transition: 'color 0.3s ease',
                                textAlign: 'center',
                                fontWeight: 'bold'
                            }}>
                                <i className="fas fa-filter" style={{ marginRight: '10px' }}></i>
                                Select Event Sources
                                <span style={{ 
                                    marginLeft: '15px', 
                                    fontSize: '14px', 
                                    color: (!includeADE && !includeTicketmaster && !includePartyflock) ? '#dc3545' : '#28a745',
                                    fontWeight: 'bold'
                                }}>
                                    {(!includeADE && !includeTicketmaster && !includePartyflock) ? '⚠️ NONE SELECTED' : '✅ READY'}
                                </span>
                            </h4>
                        )}
                        
                        {!hasProceededWithMatching && (
                            <>
                                {/* Visual Status Indicator */}
                                <div style={{
                                    marginBottom: '20px',
                                    padding: '12px 16px',
                                    backgroundColor: (!includeADE && !includeTicketmaster && !includePartyflock) ? '#f8d7da' : '#d4edda',
                                    border: `3px solid ${(!includeADE && !includeTicketmaster && !includePartyflock) ? '#dc3545' : '#28a745'}`,
                                    borderRadius: '8px',
                                    textAlign: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    color: (!includeADE && !includeTicketmaster && !includePartyflock) ? '#dc3545' : '#28a745',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {(!includeADE && !includeTicketmaster && !includePartyflock) ? 
                                        '🚫 NO EVENT SOURCES SELECTED' : 
                                        `🎯 ${(includeADE ? 'THE Dance Event Festival in Amsterdam' : '')}${(includeADE && (includeTicketmaster || includePartyflock)) ? ' + ' : ''}${includeTicketmaster ? 'TICKETMASTER' : ''}${(includeTicketmaster && includePartyflock) ? ' + ' : ''}${includePartyflock ? 'PARTYFLOCK' : ''} SELECTED`
                                    }
                                </div>
                                
                                <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center' }}>
                                    {/* Custom THE Dance Event Festival in Amsterdam Checkbox */}
                                    <div 
                                        key={`ade-${includeADE}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIncludeADE(prevState => !prevState);
                                        }}
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            cursor: 'pointer', 
                                            fontSize: '16px',
                                            padding: '15px 20px',
                                            borderRadius: '12px',
                                            backgroundColor: includeADE ? '#d4edda' : '#f8d7da',
                                            border: includeADE ? '4px solid #28a745' : '4px solid #dc3545',
                                            boxShadow: includeADE ? '0 6px 12px rgba(40, 167, 69, 0.4)' : '0 6px 12px rgba(220, 53, 69, 0.4)',
                                            transform: includeADE ? 'scale(1.08)' : 'scale(1)',
                                            transition: 'all 0.3s ease',
                                            fontWeight: 'bold',
                                            minWidth: '200px',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <div style={{
                                            width: '28px',
                                            height: '28px',
                                            border: includeADE ? '4px solid #28a745' : '4px solid #dc3545',
                                            borderRadius: '8px',
                                            marginRight: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: includeADE ? '#28a745' : '#dc3545',
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {includeADE ? (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✓</span>
                                            ) : (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✗</span>
                                            )}
                                        </div>
                                        <span style={{ 
                                            fontWeight: 'bold', 
                                            color: includeADE ? '#28a745' : '#dc3545',
                                            fontSize: '18px',
                                            textShadow: includeADE ? '0 2px 4px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(220, 53, 69, 0.3)'
                                        }}>
                                            🎵 Amsterdam Events ({includeADE ? '✅ ON' : '❌ OFF'})
                                        </span>
                                    </div>

                                    {/* Custom Ticketmaster Checkbox */}
                                    <div 
                                        key={`ticketmaster-${includeTicketmaster}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIncludeTicketmaster(prevState => !prevState);
                                        }}
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            cursor: 'pointer', 
                                            fontSize: '16px',
                                            padding: '15px 20px',
                                            borderRadius: '12px',
                                            backgroundColor: includeTicketmaster ? '#d4edda' : '#f8d7da',
                                            border: includeTicketmaster ? '4px solid #28a745' : '4px solid #dc3545',
                                            boxShadow: includeTicketmaster ? '0 6px 12px rgba(40, 167, 69, 0.4)' : '0 6px 12px rgba(220, 53, 69, 0.4)',
                                            transform: includeTicketmaster ? 'scale(1.08)' : 'scale(1)',
                                            transition: 'all 0.3s ease',
                                            fontWeight: 'bold',
                                            minWidth: '200px',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <div style={{
                                            width: '28px',
                                            height: '28px',
                                            border: includeTicketmaster ? '4px solid #28a745' : '4px solid #dc3545',
                                            borderRadius: '8px',
                                            marginRight: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: includeTicketmaster ? '#28a745' : '#dc3545',
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {includeTicketmaster ? (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✓</span>
                                            ) : (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✗</span>
                                            )}
                                        </div>
                                        <span style={{ 
                                            fontWeight: 'bold', 
                                            color: includeTicketmaster ? '#28a745' : '#dc3545',
                                            fontSize: '18px',
                                            textShadow: includeTicketmaster ? '0 2px 4px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(220, 53, 69, 0.3)'
                                        }}>
                                            🎫 TicketMaster Events ({includeTicketmaster ? '✅ ON' : '❌ OFF'})
                                        </span>
                                    </div>

                                    {/* Custom Partyflock Checkbox */}
                                    <div 
                                        key={`partyflock-${includePartyflock}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setIncludePartyflock(prevState => !prevState);
                                        }}
                                        style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            cursor: 'pointer', 
                                            fontSize: '16px',
                                            padding: '15px 20px',
                                            borderRadius: '12px',
                                            backgroundColor: includePartyflock ? '#d4edda' : '#f8d7da',
                                            border: includePartyflock ? '4px solid #28a745' : '4px solid #dc3545',
                                            boxShadow: includePartyflock ? '0 6px 12px rgba(40, 167, 69, 0.4)' : '0 6px 12px rgba(220, 53, 69, 0.4)',
                                            transform: includePartyflock ? 'scale(1.08)' : 'scale(1)',
                                            transition: 'all 0.3s ease',
                                            fontWeight: 'bold',
                                            minWidth: '200px',
                                            justifyContent: 'center'
                                        }}
                                    >
                                        <div style={{
                                            width: '28px',
                                            height: '28px',
                                            border: includePartyflock ? '4px solid #28a745' : '4px solid #dc3545',
                                            borderRadius: '8px',
                                            marginRight: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: includePartyflock ? '#28a745' : '#dc3545',
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {includePartyflock ? (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✓</span>
                                            ) : (
                                                <span style={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>✗</span>
                                            )}
                                        </div>
                                        <span style={{ 
                                            fontWeight: 'bold', 
                                            color: includePartyflock ? '#28a745' : '#dc3545',
                                            fontSize: '18px',
                                            textShadow: includePartyflock ? '0 2px 4px rgba(40, 167, 69, 0.3)' : '0 2px 4px rgba(220, 53, 69, 0.3)'
                                        }}>
                                            🎪 Partyflock Events ({includePartyflock ? '✅ ON' : '❌ OFF'})
                                        </span>
                                    </div>
                                </div>
                                
                                
                                {!includeADE && !includeTicketmaster && !includePartyflock && (
                                    <div style={{ marginTop: '15px', color: '#dc3545', fontSize: '14px', textAlign: 'center', fontWeight: 'bold' }}>
                                        <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                                        Please select at least one event source
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
                
                {/* Proceed with Matching Button - MOVED TO MAIN CONTENT FLOW */}
                {status === 204 && !hasProceededWithMatching && (
                    <div style={{ 
                        marginTop: '20px', 
                        textAlign: 'center' 
                    }}>
                        <button 
                            className="btn btn-success"
                            onClick={() => {
                                // Check if at least one source is selected
                                if (!includeADE && !includeTicketmaster && !includePartyflock) {
                                    alert('Please select at least one event source (Amsterdam Events, TicketMaster, or Partyflock)');
                                    return;
                                }
                                
                                // Mark that user has proceeded with matching
                                setHasProceededWithMatching(true);
                                
                                // Proceed with loading tracks and matching
                                setMenu(<div className="status-message waiting">Loading tracks and matching with events, please wait...</div>);
                                checkPremiumStatus();
                                fetchActivities();
                            }}
                            disabled={!includeADE && !includeTicketmaster && !includePartyflock}
                            style={{
                                backgroundColor: (!includeADE && !includeTicketmaster && !includePartyflock) ? '#6c757d' : '#28a745',
                                border: (!includeADE && !includeTicketmaster && !includePartyflock) ? '2px solid #6c757d' : '2px solid #28a745',
                                color: '#fff',
                                padding: '20px 40px',
                                borderRadius: '12px',
                                cursor: (!includeADE && !includeTicketmaster && !includePartyflock) ? 'not-allowed' : 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '12px',
                                opacity: (!includeADE && !includeTicketmaster && !includePartyflock) ? 0.6 : 1,
                                fontSize: '18px',
                                fontWeight: 'bold',
                                boxShadow: (!includeADE && !includeTicketmaster && !includePartyflock) ? 'none' : '0 6px 16px rgba(40, 167, 69, 0.4)',
                                transform: (!includeADE && !includeTicketmaster && !includePartyflock) ? 'scale(1)' : 'scale(1.05)',
                                transition: 'all 0.3s ease',
                                minWidth: '300px'
                            }}
                        >
                            <i className="fas fa-play" style={{ fontSize: '20px' }}></i>
                            {(!includeADE && !includeTicketmaster && !includePartyflock) ? '❌ Select Event Sources First' : '🚀 Proceed with Matching'}
                        </button>
                    </div>
                )}
                
                {/* Simple Map Component - Fallback */}
                {mapMarkers.length > 0 && (
                    <div style={{ 
                        marginTop: '30px', 
                        marginBottom: '20px',
                        backgroundColor: '#2a2a2a',
                        borderRadius: '12px',
                        padding: '20px',
                        border: '2px solid #444'
                    }}>
                        <h4 style={{ 
                            color: '#fff', 
                            marginBottom: '15px', 
                            textAlign: 'center',
                            fontSize: '18px',
                            fontWeight: 'bold'
                        }}>
                            <i className="fas fa-map-marker-alt" style={{ marginRight: '8px', color: '#F59E0B' }}></i>
                            Event Locations Map
                        </h4>
                        <div style={{ 
                            height: '500px', 
                            width: '100%', 
                            borderRadius: '8px',
                            border: '2px solid #F59E0B',
                            overflow: 'hidden',
                            position: 'relative',
                            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.2)'
                        }}>
                            {/* Leaflet Map */}
                            <div 
                                id="leaflet-map" 
                                style={{ 
                                    width: '100%', 
                                    height: '100%',
                                    borderRadius: '6px'
                                }}
                            />
                            {/* Map info overlay */}
                            <div style={{
                                position: 'absolute',
                                top: '15px',
                                right: '15px',
                                backgroundColor: 'rgba(0,0,0,0.8)',
                                padding: '12px',
                                borderRadius: '8px',
                                color: '#fff',
                                fontSize: '12px',
                                textAlign: 'center',
                                border: '1px solid rgba(255,255,255,0.2)',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                zIndex: 1000
                            }}>
                                <div style={{ fontWeight: 'bold', color: '#F59E0B' }}>{mapMarkers.length} Events</div>
                                <div style={{ fontSize: '10px', opacity: 0.8 }}>Interactive Leaflet Map</div>
                            </div>
                        </div>
                        
                        {/* Map legend */}
                        <div style={{
                            marginTop: '15px',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px',
                            flexWrap: 'wrap'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', color: '#fff', fontSize: '14px' }}>
                                <div style={{ width: '12px', height: '12px', backgroundColor: '#00d4ff', borderRadius: '50%', marginRight: '8px', border: '2px solid #fff' }}></div>
                                ADE Events
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', color: '#fff', fontSize: '14px' }}>
                                <div style={{ width: '12px', height: '12px', backgroundColor: '#ff6b35', borderRadius: '50%', marginRight: '8px', border: '2px solid #fff' }}></div>
                                Ticketmaster
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', color: '#fff', fontSize: '14px' }}>
                                <div style={{ width: '12px', height: '12px', backgroundColor: '#9c27b0', borderRadius: '50%', marginRight: '8px', border: '2px solid #fff' }}></div>
                                Partyflock
                            </div>
                        </div>
                        
                        {/* Map info */}
                        <div style={{
                            marginTop: '10px',
                            textAlign: 'center',
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: 'bold'
                        }}>
                            {mapMarkers.length} Events Found
                            <div style={{
                                marginTop: '5px',
                                fontSize: '12px',
                                color: '#F59E0B',
                                fontStyle: 'italic'
                            }}>
                                <i className="fas fa-check-circle" style={{ marginRight: '5px' }}></i>
                                All events displayed with interactive markers
                            </div>
                        </div>
                    </div>
                )}
                
                {listItems && (
                    <div className="matched-tracks-container">
                        <div className="sort-controls">
                            <div className="sort-buttons">
                                <button 
                                    className={`sort-button ${sortBy === 'tracks' ? 'active' : ''}`}
                                    onClick={() => setSortBy('tracks')}
                                >
                                    <i className="fas fa-music"></i>
                                    Sort by Tracks
                                </button>
                                <button 
                                    className={`sort-button ${sortBy === 'date' ? 'active' : ''}`}
                                    onClick={() => setSortBy('date')}
                                >
                                    <i className="fas fa-calendar-alt"></i>
                                    Sort by Date
                                </button>
                            </div>
                        </div>
                        {listItems}
                        
                        {/* Premium upgrade prompt for non-premium users */}
                        {!isPremium && metadata && (
                            <div className="premium-upgrade-section">
                                <h3 className="premium-title">
                                    <i className="fas fa-music"></i>
                                    Unlock All Your Matches!
                                </h3>
                                <p className="premium-description">
                                    You're seeing the top 3 events with {metadata.total_tracks - metadata.remaining_tracks} tracks and {metadata.total_artists - metadata.remaining_artists} artists.
                                    <br />
                                    <strong>Get Lifetime Premium Access</strong> to see all {metadata.total_events} events with {metadata.remaining_tracks} more tracks and {metadata.remaining_artists} more artists!
                                </p>
                                <div className="premium-badges">
                                    <span className="premium-badge events">
                                        {metadata.remaining_events} More Events
                                    </span>
                                    <span className="premium-badge tracks">
                                        {metadata.remaining_tracks} More Tracks
                                    </span>
                                    <span className="premium-badge artists">
                                        {metadata.remaining_artists} More Artists
                                    </span>
                                </div>
                                <button 
                                    className="premium-button"
                                    onClick={() => window.location.href = '/admin/payment'}
                                >
                                    <i className="fas fa-star"></i>
                                    Get Lifetime Premium - €0.50 (Temporary Price)
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </div>
                        {/* Display the My Event Calendar content from content.json */}
                        <div className="myeventcalendar-content">
                <HtmlContent html={content.features.myeventcalendar} />
            </div>

        </div>
        
        {/* Firebase Authentication Modal */}
        <AuthModal
            isOpen={showAuthModal}
            toggle={() => setShowAuthModal(!showAuthModal)}
            onAuthSuccess={handleAuthSuccess}
            onAuthError={handleAuthError}
        />
        </>
    );
}

export default App;
